module.exports = __webpack_public_path__ + "static/media/emeralddp.7308f23d.jpg";